
import React, { useState } from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import SectionHeading from '@/components/ui/section-heading';

interface Testimonial {
  id: number;
  quote: string;
  author: string;
  rating: number;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "After installing Forti-Fi's fiber solution, we've had zero security breaches in our 50-acre estate.",
    author: "Estate Manager, Ontario",
    rating: 5
  }, 
  {
    id: 2,
    quote: "The invisible security perimeter handles our harsh Canadian winters without any maintenance issues.",
    author: "Property Developer",
    rating: 4.8
  }
];

const FibreTestimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  return (
    <section aria-labelledby="testimonials-heading" className="section bg-forti-fi-background py-[79px] bg-[#afffce]/[0.16]">
      <div className="container mx-auto max-w-4xl">
        <AnimateInView>
          <SectionHeading 
            title="What Our Clients Say"
            className="text-center mb-8"
            titleClassName="text-forti-fi-teal"
          />
        </AnimateInView>
        
        <div className="bg-white p-8 rounded-lg shadow-md relative overflow-hidden">
          <AnimateInView key={activeTestimonial} animation="fade-in">
            <div className="relative z-10">
              <div className="text-4xl text-forti-fi-teal mb-4">"</div>
              <p className="text-lg mb-6 text-forti-fi-charcoal italic">
                {testimonials[activeTestimonial].quote}
              </p>
              <div className="flex justify-between items-center">
                <p className="font-medium text-forti-fi-teal">
                  {testimonials[activeTestimonial].author}
                </p>
                <div className="flex">
                  {Array.from({
                  length: 5
                }).map((_, i) => (
                    <span 
                      key={i} 
                      className={i < Math.floor(testimonials[activeTestimonial].rating) ? "text-amber-500" : "text-gray-300"}
                    >
                      ★
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </AnimateInView>
          
          {/* Testimonial navigation dots */}
          <div className="flex justify-center mt-6">
            {testimonials.map((_, index) => (
              <button 
                key={index} 
                onClick={() => setActiveTestimonial(index)} 
                className={`w-2 h-2 mx-1 rounded-full transition-colors ${index === activeTestimonial ? "bg-forti-fi-teal" : "bg-gray-300"}`} 
                aria-label={`View testimonial ${index + 1}`} 
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FibreTestimonials;
